<template>
  <v-dialog :model-value="visible" persistent max-width="420">
    <v-card>
      <v-card-title>Code porteur CPS</v-card-title>
      <v-card-text>
        <p class="mb-2">Entrez le code porteur de votre carte CPS.</p>
        <v-text-field v-model="code" type="password" inputmode="numeric"
                      maxlength="4" autocomplete="one-time-code"
                      label="Code porteur" @input="onInput"
                      @keyup.enter="valider" data-testid="saisie-pin-cps" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="annuler">Annuler</v-btn>
        <v-btn color="primary" :disabled="code.length !== 4" @click="valider">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { resoudrePin, annulerPin } from '@/script/pinCps';

export default {
    name: 'DialogSaisiePin',
    data() { return { code: '' }; },
    computed: {
        visible() { return this.$store.getters['Cps/getPinDialogVisible']; },
    },
    methods: {
        onInput() { this.code = this.code.replace(/\D/g, '').slice(0, 4); },
        valider() {
            if (this.code.length !== 4) return;
            const code = this.code;
            this.code = ''; // ne pas conserver le PIN
            resoudrePin(this.$store, code);
        },
        annuler() {
            this.code = '';
            annulerPin(this.$store);
        },
    },
};
</script>
